export default __webpack_public_path__ + "static/media/plus.887d2aad.svg";